import {
  AIModelPreference,
  AIPrimaryUseCase,
  AIReadinessLevel,
  AutomationExperience,
  CompanySize,
  TeamTechnicalLevel,
} from '@/types/profile'
import * as z from 'zod'

export const USER_SCHEMA = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
})

export const USER_PROFILE_SCHEMA = z.object({
  bio: z.string().optional(),
})

export const USER_PROFILE_AI_QUESTIONS_REQUIRED_SCHEMA = z
  .object({
    aiReadiness: z.nativeEnum(AIReadinessLevel, {
      error: 'Please select a valid AI readiness level ',
    }),
    teamTechnicalLevel: z.nativeEnum(TeamTechnicalLevel, {
      error: 'Please select a valid team technical level',
    }),
    aiModelPreferences: z.array(z.nativeEnum(AIModelPreference), {
      error: 'Please select a valid AI model preference',
    }),
    companySize: z.nativeEnum(CompanySize, {
      error: 'Please select a valid company size',
    }),
    automationExperience: z.nativeEnum(AutomationExperience, {
      error: 'Please select a valid automation experience',
    }),
    aiPrimaryUseCase: z.nativeEnum(AIPrimaryUseCase, {
      error: 'Please select a valid AI primary use case',
    }),
  })
  .required()
